import React, {useRef, useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Label from '@mui/material/FormLabel';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

import ArrowForward from '@mui/icons-material/ArrowForward';

import {SectionProps} from '../../types/form';
import CnhTypeError from '../errors/CnhTypeError';


const Section4 = (props: SectionProps) => {

    const {handleNext, values, setValues} = props;

    /**
     * FORM SUBMIT TO NEXT SECTION
     */
    const formRef = useRef<HTMLFormElement>(null)
    const [cnhTypeError, setCnhTypeError] = useState(false);

    const handleNextClick = () => {
        if (!formRef.current) {
            return;
        }

        formRef.current.reportValidity();

        // Validate CNH type
        if (!['E', 'AE'].includes(values['cnh_type'])) {
            setCnhTypeError(true);
            return;
        }

        if (formRef.current.checkValidity()) {
            handleNext();
        }
    };

    if (cnhTypeError) {
        return (<CnhTypeError/>);
    }

    return (
        <Box>
            <Typography variant={'h2'}>
                CNH
            </Typography>

            <Box component={'form'} ref={formRef}>
                <Stack direction={'column'} spacing={3}>
                    <FormControl fullWidth>
                        <Label sx={{mb: 1}}>Categoria da CNH *</Label>
                        <Select
                            required
                            fullWidth
                            variant={'outlined'}
                            value={values['cnh_type']}
                            onChange={(e) => setValues({...values, cnh_type: e.target.value})}
                        >
                            {['A', 'B', 'AB', 'C', 'AC', 'D', 'AD', 'E', 'AE'].map((type) => (
                                <MenuItem key={type} value={type}>{type}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>

                <Stack direction={'row'} justifyContent={'end'} sx={{mt: 5}}>
                    <Button variant={'contained'} onClick={handleNextClick}>
                        Próximo
                        <ArrowForward fontSize={'small'} sx={{ml: 2}}/>
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
};

export default Section4;